<template>
  <div>
    <template v-if="loaded">
      <div class="is-flex">
        <p class="has-text-weight-bold is-size-4">
          #{{ id }}: {{ application.flowName }}
        </p>
        <b-tag type="is-success" class="ml-auto">{{
          $t(LOAN_APPLICATION_STATUS_TOKENS[application.currentStatus])
        }}</b-tag>
      </div>

      <div class="mp-card">
        <ApplicationDetailsDynamicData
          :applicationId="id"
          :application="application"
        />

        <ApplicationDetailsStatements :applicationId="id" />

        <ApplicationDetailsUploadedDocuments :applicationId="id" />

        <ApplicationDetailsGeneratedAndSignedDocuments :applicationId="id" />
      </div>
    </template>

    <LoadingSkeleton v-else />
  </div>
</template>

<script>
import LoadingSkeleton from "../components/LoadingSkeleton";
import { LOAN_APPLICATION_STATUS_TOKENS } from "../utils/const";
import ApplicationDetailsDynamicData from "../components/application-details/ApplicationDetailsDynamicData";
import ApplicationDetailsStatements from "../components/application-details/ApplicationDetailsStatements";
import ApplicationDetailsUploadedDocuments from "../components/application-details/ApplicationDetailsUploadedDocuments";
import ApplicationDetailsGeneratedAndSignedDocuments from "../components/application-details/ApplicationDetailsGeneratedAndSignedDocuments";

export default {
  name: "ApplicationDetails",
  title: "mp:page.application_details.title",
  props: {
    id: {
      type: String,
    },
  },
  components: {
    ApplicationDetailsGeneratedAndSignedDocuments,
    ApplicationDetailsUploadedDocuments,
    ApplicationDetailsDynamicData,
    ApplicationDetailsStatements,
    LoadingSkeleton,
  },
  async mounted() {
    await this.$store.dispatch("applicationAdmin/fetchDetails", this.id);
    this.application = this.$store.getters["applicationAdmin/getDetails"](
      this.id
    );

    this.loaded = true;
  },
  data() {
    return {
      LOAN_APPLICATION_STATUS_TOKENS,
      loaded: false,
      application: {},
    };
  },
};
</script>
